export default __webpack_public_path__ + "static/media/bleached.ff6a1e07.jpg";